import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ig-card-action',
    templateUrl: './card.action.component.html',
    styleUrls: ['./card.action.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CardActionComponent {
    @Input() public icon: string;

    constructor() {
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/water.fall.container/card/action/card.action.component.ts